import styled from 'styled-components'
import { Card as DdsCard } from '@diversioteam/diversio-ds'

export const BlankWrapper = styled(DdsCard)`
    flex: 1;
    gap: 48px;
    min-width: 680px;

    &.dds-card {
        align-items: stretch;
        padding: 48px 30px;
    }

    .MuiSkeleton-root {
        flex: 1;
        border-radius: 15px;
    }
`
